export default __webpack_public_path__ + "assets/Pool8Ball.svg";